// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { partNumberStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsPartNumber";
import { css } from "styled-components";

partNumberStyles.labelText = {
    size: 16,
    weight: "bold",
    css: css`
        margin-right: 15px;
    `,
};
partNumberStyles.valueText = {
    size: 16,
    css: css`
        margin-bottom: 5px;
    `,
};
partNumberStyles.partNumberText = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            weight: "bold",
            size: 14,
            css: css`
                line-height: 16px;
                &:after {
                    content: ":";
                }
            `,
        },
        text: {
            weight: 400,
            size: 14,
            css: css`
                line-height: 21px;
            `,
        },
    }),
};
